import { axiosService } from "./axiosService";

const notificationApi = {
    getAll(params) {
        const url = '/notify';
        return axiosService.get(url, { params })
    },
    getUnread() {
        const url = '/notify-unread';
        return axiosService.get(url)
    },
    send(body) {
        const url = '/notify';
        return axiosService.post(url, body)
    },
    update(id, body) {
        const url = `/notify/${id}`;
        return axiosService.put(url, body)
    },
    markAsRead(id) {
        const url = `/notify-mark-as-read/${id}`;
        return axiosService.post(url)
    },
    delete(id) {
        const url = `/notify/${id}`;
        return axiosService.delete(url)
    }
}

export default notificationApi;